/*  ==========================================================================
		PHP Variables
		========================================================================== */

// If you need to access variables such as template url, or AJAX url within this file you can use the variable php_variables.template_url or php_variables.ajax_url
// which has been passed in via enqueue-scripts.php

/*  ==========================================================================
		Grid variables - needed for gridcarousel__init
		========================================================================== */

// NOTE: If your updating this make sure to also update the SASS Variables in _variables.scss
const gridSizes = {
  sm: "550",
  md: "700",
  lg: "1000",
  xl: "1200",
  ws: "1400",
  xw: "1600",
  xxw: "1800",
  xxxw: "2000"
};

/*  ==========================================================================
      DOM element variables 
      ========================================================================== */

const body = document.querySelector("body");

/*  ==========================================================================
		Device Detection - Check if is mobile or ipad
		========================================================================== */

let isMobile = false; // initiate as false
const isTouchDevice = !!("ontouchstart" in window);

if (/Android|webOS|iPhone|iPod|BlackBerry|IEMobile|Opera Mini/i.test(window.navigator.userAgent)) {
  isMobile = true;
}

/*  ==========================================================================
		GENERAL - add linklines to links
		========================================================================== */

const linksInit = function () {
  const links = document.querySelectorAll("a:not(.noline):not(.line--added)");
  links.forEach(function (el) {
    if (el.closest(".noline")) {
      return;
    }

    const icon = el.querySelector(".fa, .fas, .far, .fal, .fab");

    if (el.querySelector("img") < 1) {
      const linkHTML = "<span class='linkline'>" + el.textContent + "</span>";
      el.innerHTML = linkHTML;
      el.classList.add("line--added");
      if (icon) {
        const iconHTML = icon;
        if (icon.classList.contains("fa--left")) {
          el.querySelector(".linkline").before(icon);
        } else {
          el.querySelector(".linkline").after(icon);
        }
      }
    }
  });
  //return true;
}; // linksInit();
linksInit();

/*  ==========================================================================
    GENERAL - sharinglinks
    ========================================================================== */

const sharingLinksInit = function () {
  const links = document.querySelector(".shareiconslist");

  if (!links) {
    return;
  }

  links.addEventListener("click", function (e) {
    e.preventDefault();
    const clicked = e.target.closest(".sharelink--popup");

    if (!clicked) {
      return;
    }

    const shareURL = clicked.getAttribute("href");
    window.open(shareURL, "share-dialog", "width=550,height=436");
  });
}; // sharingLinksInit();
sharingLinksInit();

/*  ==========================================================================
    GENERAL - accordion
    ========================================================================== */

const accordionQuestions = document.querySelectorAll(".accordion__question");

const accordionInit = function (accordionItems) {
  if (!accordionItems) {
    return;
  }

  accordionItems.forEach(item =>
    item.addEventListener("click", function () {
      item.closest(".accordion__item").classList.toggle("accordion__item--open");
    })
  );
}; // accordionInit();
accordionInit(accordionQuestions);

/*  ==========================================================================
    GENERAL - LazyLoad - Enable Lazy load for images
    ========================================================================== */

// Lazy load images (or everything with .lazy)
const lazyLoadInstance = new LazyLoad();

/*  ==========================================================================
    GENERAL - Initiate plyr (custom video controls)

    This is automatically disabled on builds, to enable uncomment the JS here
    and then go to functions / enqueue-scripts and enqueue-styles to uncomment and enable the css and JS 

    ========================================================================== */

let players = false;
const plyrsInit = function () {
  players = Array.from(document.querySelectorAll(".plyrvideo")).map(
    plyr =>
      new Plyr(plyr, {
        controls: ["play", "progress", "mute", "settings", "fullscreen"],
        hideControls: true,
        invertTime: false,
        tooltips: { controls: false, seek: false }
      })
  );

  // Pause all other instances except the one you want to target
  players.forEach((player, index) => {
    player.on("play", () => {
      players.forEach((otherPlayer, otherIndex) => {
        if (index !== otherIndex) {
          otherPlayer.pause();
        }
      });
    });
  });
}; // plyrsInit();

plyrsInit();

/*  ==========================================================================
    GENERAL - Fancybox - Enable Lazy load for images
    ========================================================================== */

function setupFancyboxEvents() {
  $("[data-fancybox]").fancybox({
    touch: false,
    beforeShow: function (fb, item) {
      if (item.src.includes("companies/") || item.src.includes("people/") || item.src.includes("case-studies/")) {
        // Get the slug
        let item_src = item.src;
        let item_src_last = item_src.split("/");
        let item_slug = item_src_last[item_src_last.length - 2];
        let item_posttype_slug = item_src_last[item_src_last.length - 3];
        // Set it as a query parameter
        history.pushState({}, "", "#" + item_slug);
      }
    },
    afterLoad: function (instance, slide, current) {
      // //adding history
      // history.pushState({}, "", current.src);

      // Get ".fancybox-content", for this fancybox
      let thisContent = this.$content[0];

      // Re-init links to make sure linklines on newly loaded content still work
      linksInit();

      // Re-init lazy load
      lazyLoadInstance.update(); // reinit lazy load after clones

      pagenavInnit();

      // Re-init effects
      const fancyboxeffects = thisContent.querySelectorAll(".fancybox-content .effect");
      effectsInit(fancyboxeffects, thisContent);

      // Re-init carousels
      const gridCarousels = thisContent.querySelectorAll(".row--carousel .owl-carousel");
      gridCarouselInit(gridCarousels);

      // Re-init odometer
      const statsModules = thisContent.querySelectorAll(".statisticsheading__value");
      statInit(statsModules, thisContent);

      // Players init
      plyrsInit();

      // Re setup on any links within the fancybox!
      setupFancyboxEvents();

      window.onpopstate = function () {
        $.fancybox.close();
      };
    },
    onInit: function () {},
    afterClose: function () {
      // remove hash / pop-up url
      history.pushState("{}", "", window.location.pathname + window.location.search);
    }
  });

  // Check for existing pop-up and open it
  let popup_hash = window.location.hash;
  if (popup_hash) {
    var popup_hash_slug = popup_hash.replace("#", "");
    if (popup_hash_slug) {
      $("[data-slug='" + popup_hash_slug + "']").click();
    }
  }
}

setupFancyboxEvents();

/*  ==========================================================================
    GENERAL - Sub Sectors
    ========================================================================== */

const subSectorsSection = document.querySelectorAll(".sub__sectors__section");

const subSectorsInit = function (subSectorsSection) {
  if (!subSectorsSection) {
    return;
  }

  subSectorsSection.forEach(subSectorSection => {
    const subSectorsCol = subSectorSection.querySelectorAll(".sector-col");

    subSectorsCol.forEach(col => {
      col.addEventListener("click", function (e) {
        let subSectors = subSectorSection.querySelector(".sub__sectors");

        let thisCol = e.target;
        subSectorsCol.forEach(col => {
          if (col !== thisCol) {
            col.classList.remove("sector-col--active");
          }
        });

        subSectors.classList.add("sub__sectors--active");
        col.classList.add("sector-col--active");
      });
      if ($(window).width() > gridSizes.xl) {
        let sectorHeading = col.querySelector(".sector-heading");
        sectorHeading.style.height = col.offsetHeight + "px";

        $(window).on("resize", function () {
          let sectorHeading = col.querySelector(".sector-heading");
          sectorHeading.style.height = col.offsetHeight + "px";
        });
      }
    });
  });
}; // subSectorsInit();
subSectorsInit(subSectorsSection);

/*  ==========================================================================
	GENERAL - Popup
		========================================================================== */

const pagePopup = document.querySelector("#popup");

const pagePopupInit = function (pagePopup) {
  if (!pagePopup) {
    return;
  }

  function setCookie(name, value, days) {
    const expires = new Date(Date.now() + days * 86400 * 1000).toUTCString();
    document.cookie = `${name}=${value}; expires=${expires}; path=/`;
  }

  function getCookie(name) {
    const match = document.cookie.match(new RegExp("(^| )" + name + "=([^;]+)"));
    return match ? match[2] : null;
  }

  // Main Logic
  if (!getCookie("closedpopup")) {
    setTimeout(() => {
      if (typeof $.fancybox !== "undefined") {
        $.fancybox.open({
          src: "#popup",
          type: "inline",
          touch: false,
          clickSlide: false,
          closeClickOutside: false,
          closeButton: false,
          keyboard: false,
          trapFocus: false,
          helpers: {
            overlay: { closeClick: false }
          }
        });
      }
    }, 8000); // 8 seconds
  }
  const closePopup = document.querySelector("#close__popup");

  closePopup.addEventListener("click", function (e) {
    setCookie("closedpopup", "true", 90);
    $.fancybox.close();
  });
};

pagePopupInit(pagePopup);

/*  ==========================================================================
    AJAX - AJAX load more / paging
    ========================================================================== */

const loadmoreBtn = document.querySelector(".paging__loadmore");
const loadmoreContainer = document.querySelector(".loadmore-container");

const loadmoreLoadPostsMultiplePages = function (pages) {
  if (pages && pages > 1) {
    //Stopping default scroll back to previous position
    history.scrollRestoration = "manual";

    const currentPage = new URL(window.location);

    //Creating an array on page numbers to map it
    var list = [];
    for (var i = 1; i < pages; i++) {
      list.push(i);
    }

    // Initialising the array of posts pages
    var postsHTML = [];

    const button = loadmoreBtn;
    const buttonText = button.textContent; // store current button text
    button.textContent = "Loading..."; // change the button text, to let the user know we are loading more posts

    // Array of ajax calls
    var allAJAX = list.map(function (page) {
      const data = {
        action: "loadmore",
        query: php_variables.posts, // that's how we get params from wp_localize_script() function
        page: page
      };
      //Updating the url to mtch the page number
      currentPage.searchParams.set("pagenum", page);
      return $.ajax({
        url: php_variables.ajax_url, // AJAX handler
        data: data,
        type: "POST",
        success: function (data) {
          postsHTML[page] = data;
        }
      });
    });

    // Waiting for all the ajax calls to be finished before proceeding
    Promise.all(allAJAX).then(function () {
      // Update current page variable
      php_variables.current_page = pages;

      button.textContent = buttonText; // set back to previous button text

      // Adding the new tiles to the dom
      list.map(page => {
        if (postsHTML[page]) {
          loadmoreContainer.innerHTML = loadmoreContainer.innerHTML + postsHTML[page];
        }
      });

      // Updating the href for the loadmore button
      const nextPage = new URL(window.location);
      nextPage.searchParams.set("pagenum", parseInt(pages) + 1);
      button.href = nextPage;

      // if last page, remove the button..
      if (parseInt(php_variables.current_page) === parseInt(php_variables.max_page)) {
        button.style.display = "none";
      }

      // Re-init links to make sure linklines on newly loaded content still work
      linksInit();
      // Re-init lazy load
      lazyLoadInstance.update(); // reinit lazy load after clones

      // Re-init effects
      const effects = document.querySelectorAll(".effect");
      effectsInit(effects);

      // Re-do fancybox events
      setupFancyboxEvents();

      // Scrolling the page to the last known position
      if (localStorage.getItem("scrollPosition")) {
        window.scroll({
          top: parseInt(localStorage.getItem("scrollPosition"), 10),
          behavior: "instant"
        });
      }
    });
  }
};

const loadmoreLoadPosts = function () {
  const button = this;
  const data = {
    action: "loadmore",
    query: php_variables.posts, // that's how we get params from wp_localize_script() function
    page: php_variables.current_page
  };
  let buttonText; // create variable to store button text

  // This AJAX triggers a PHP hook within function-hooks.php called ajax_loadmore_handler
  $.ajax({
    url: php_variables.ajax_url, // AJAX handler
    data: data,
    type: "POST",
    beforeSend: function (xhr) {
      buttonText = button.textContent; // store current button text
      button.textContent = "Loading..."; // change the button text, to let the user know we are loading more posts
    },
    success: function (data) {
      if (data) {
        button.textContent = buttonText; // set back to previous button text
        loadmoreContainer.innerHTML = loadmoreContainer.innerHTML + data; // insert new posts to the loadmore-container, this should be the row that includes the posts
        php_variables.current_page++;

        // Only push state to set the last page number or if there is more pages to load
        const currentPage = new URL(window.location);

        if (parseInt(php_variables.current_page) <= parseInt(php_variables.max_page)) {
          currentPage.searchParams.set("pagenum", php_variables.current_page);
          history.pushState({}, "", currentPage);
        }

        // if last page, remove the button..
        if (parseInt(php_variables.current_page) === parseInt(php_variables.max_page)) {
          button.style.display = "none";
        }
        // Re-init links to make sure linklines on newly loaded content still work
        linksInit();
        // Re-init lazy load
        lazyLoadInstance.update(); // reinit lazy load after clones
        // Re-init effects
        effectsInit();
        // Re-do fancybox events
        setupFancyboxEvents();
      } else {
        button.remove(); // if no data, remove the button as well
      }
    }
  });
}; // loadmoreLoadPosts();

const loadmoreInit = function () {
  if (!loadmoreBtn) {
    return;
  }

  /** When adding fitering you will need to move this part into the filtering call */
  // Checking if the page paramenter is set
  const currentPage = new URL(window.location);
  let currentPageNum = currentPage.searchParams.get("pagenum");

  //If there is more than one page to load
  if (currentPageNum && currentPageNum > 1) {
    currentPageNum = parseInt(currentPageNum) > parseInt(php_variables.max_page) ? php_variables.max_page : currentPageNum;
    loadmoreLoadPostsMultiplePages(currentPageNum);
  }

  loadmoreBtn.addEventListener("click", loadmoreLoadPosts);
}; // loadmoreInit();
loadmoreInit();

/*  ==========================================================================
      Page transition
      ========================================================================== */

// // Add class to say that the page is transitioning
// document.body.classList.add("page-transitioning");
// document.body.classList.add("page-transitioning--in");

// // Function to slide out panels & text on page loaded
// function transitionOut() {
//   $(".transition__text")
//     .stop(true, true)
//     .delay(250)
//     .animate(
//       {
//         top: "25%",
//         opacity: 0
//       },
//       200,
//       $.bez([0.33, 1, 0.68, 1]),
//       function () {}
//     );

//   $(".transition__bg")
//     .stop(true, true)
//     .delay(550)
//     .animate(
//       {
//         top: "-100%"
//       },
//       200,
//       $.bez([0.33, 1, 0.68, 1]),
//       function () {
//         $("body").addClass("page-ready");
//         $(".transition__bg").css("top", "100%");
//       }
//     );

//   // Counteract animation on logo wrap, to keep it in the same position as the fixed siteheader logo
//   $(".transition__logowrap")
//     .stop(true, true)
//     .delay(550)
//     .animate(
//       {
//         top: "100%"
//       },
//       200,
//       $.bez([0.33, 1, 0.68, 1]),
//       function () {
//         $(".transition__logowrap").css("top", "-100%");
//       }
//     );

//   setTimeout(function () {
//     document.body.classList.remove("page-transitioning");
//     document.body.classList.remove("page-transitioning--in");
//     document.body.classList.add("page-ready");

//     const effects = document.querySelectorAll(".effect");

//     effectsInit(effects, window);
//   }, 200);
// }

// // On page open, start by transitioning text and then checking page load.
// $(".transition__text")
//   .stop(true, true)
//   .animate(
//     {
//       top: "50%",
//       opacity: 1
//     },
//     750,
//     $.bez([0.86, 0, 0.07, 1]),
//     function () {
//       // not waiting for image load, as the image is lower on the page
//       transitionOut();
//     }
//   );

// // Track all link clicks to start transition

// $(document).on("click", "a", function (event) {
//   if ($(this).attr("target") !== "_blank" && $(this).attr("data-type") !== "ajax") {
//     /// detect any links we don't want the transition to happen on.
//     if (
//       !$(this).hasClass("notransition") &&
//       !$(this).hasClass("sharelink") &&
//       !$(this).hasClass("scrolltolink") &&
//       !$(this).hasClass("teamsfilter__link")
//     ) {
//       if (
//         $(this).attr("href") !== undefined &&
//         $(this).attr("href") !== "" &&
//         $(this).attr("href") !== "#" &&
//         $(this).attr("href") !== "#companynews" &&
//         $(this).attr("href") !== "#searchpopup" &&
//         $(this).attr("href") !== "#!" &&
//         $(this).attr("href") !== "#mobnav"
//       ) {
//         var destination = $(this).attr("href");
//         var fancybox = $(this).data("fancybox");

//         if (!destination.includes("tel:") && !destination.includes("mailto:") && !fancybox) {
//           // Element 'a' has href
//           event.preventDefault();

//           // Add class to
//           document.body.classList.remove("page-ready");
//           document.body.classList.add("page-transitioning");
//           document.body.classList.add("page-transitioning--out");

//           // Slide in transition cover
//           $(".transition__bg")
//             .stop(true, true)
//             .delay(50)
//             .animate(
//               {
//                 top: "0%"
//               },
//               200,
//               $.bez([0.33, 1, 0.68, 1]),
//               function () {
//                 window.open(destination, "_self");
//               }
//             );

//           // Counteract animation on logo wrap, to keep it in the same position as the fixed siteheader logo
//           $(".transition__logowrap")
//             .stop(true, true)
//             .delay(50)
//             .animate(
//               {
//                 top: "0%"
//               },
//               200,
//               $.bez([0.33, 1, 0.68, 1]),
//               function () {}
//             );
//         }
//       }
//     }
//   }
// });

// /* Fix issue with safari caching page fade out */
// $(window).bind("pageshow", function (event) {
//   if (event.originalEvent.persisted) {
//     window.location.reload();
//   }
// });

/*  ==========================================================================
    Scroll effects
    ========================================================================== */
const effects = document.querySelectorAll(".effect");

const effectsInit = function (effects, context) {
  if (!effects) {
    return;
  }

  effects.forEach(function (val) {
    const waypoints = new Waypoint({
      element: val,
      handler: function (direction) {
        if (direction === "down") {
          val.classList.add("effect--ready");
        } else {
          val.classList.remove("effect--ready");
        }
      },
      context: context,
      offset: "95%"
    });
  });
}; // effectsInit();

effectsInit(effects);
/*  ==========================================================================
  Rellax: Parallax Effects
  ========================================================================== */

const rellaxInit = function () {
  const rellax = new Rellax(".rellax", {
    center: true,
    round: true,
    vertical: true,
    horizontal: false,
    breakpoints: [576, 768, 1201]
  });
};
rellaxInit();

/*  ==========================================================================
    statistics count up
    ========================================================================== */

const statsModules = document.querySelectorAll(".statisticsheading__value");

const statInit = function (statsModules, context) {
  statsModules.forEach(val => {
    const od = new Odometer({
      el: val,
      value: val.innerHTML,
    });
    const waypoints = new Waypoint({
      element: val,
      handler: function (direction) {
        if (direction === "down") {
          od.update(val.dataset.statValue);
        }
      },
      context: context,
      offset: "70%"
    });
  });
}; // statInit()
statInit(statsModules);

/*  ==========================================================================
			Grid Carousel (Currently used on Featured Posts & Featured People)
			========================================================================== */

const gridCarousels = document.querySelectorAll(".row--carousel .owl-carousel");

const gridCarouselInit = function (gridCarousels) {
  if (gridCarousels.length <= 0) {
    return;
  }

  gridCarousels.forEach(elem => {
    const slides = elem.querySelectorAll(".col");
    if (!slides) {
      return;
    }

    const responsiveArray = carouselResponsiveArray(elem);

    // Optional data attribute settings
    const autoplay = elem.dataset.autoplay ? elem.dataset.autoplay : false;
    const autoplayTimeout = elem.dataset.autoplayTimeout ? elem.dataset.autoplayTimeout : 5000;
    const loop = elem.dataset.loop ? elem.dataset.loop : false;
    const nav = elem.dataset.nav ? elem.dataset.nav : false;
    const dots = elem.dataset.dots ? elem.dataset.dots : false;
    // Default for autoheight is "true", so to turn off you need to set the data-attribute to "disable"
    const autoHeight = elem.dataset.autoHeight && elem.dataset.autoHeight === "disable" ? false : true;

    $(elem).owlCarousel({
      autoplay: autoplay,
      autoplayTimeout: autoplayTimeout,
      loop: loop,
      nav: nav,
      dots: dots,
      items: 1,
      navText: ["<i class='fal fa-arrow-left'></i>", "<i class='fal fa-arrow-right'></i>"],
      responsive: responsiveArray,
      startPosition: slides.length,
      autoHeight: autoHeight
    });
    $(elem).on("changed.owl.carousel", function (event) {
      if ($(elem).hasClass("hasvideo")) {
        // Pausing all videos on carousel transition
        players.forEach(player => {
          player.pause();
        });

        window._wq = window._wq || [];

        const wistiaVideos = elem.querySelectorAll(".wistia_embed--widthcontrols");

        wistiaVideos.forEach(item => {
          const videoID = item.id;
          _wq.push({
            id: videoID,
            onReady: function (video) {
              video.pause();
            }
          });
        });
      }
    });
    setTimeout(function () {
      $(elem).trigger("refresh.owl.carousel");
    }, 1000);

    $(elem).on("resized.owl.carousel", function (event) {
      // Refresh waypoints on resize with slight delay - bit of a hack but stop its breaking waypoint animations
      setTimeout(function () {
        Waypoint.refreshAll();
      }, 500);
    });
  });
}; // gridCarouselInit();
gridCarouselInit(gridCarousels);

/*  ==========================================================================
    Grid Carousel - Create responsive array 
    ========================================================================== */

function carouselResponsiveArray(elem) {
  let responsiveArray = {};
  const slides = elem.querySelectorAll(".col");
  const classes = slides[0].classList;

  classes.forEach((cl, index) => {
    if (cl.indexOf("col-") !== -1) {
      let className = cl;
      let classWidth = 0;
      let numItems = 4;
      className = cl.replace("col-", "");
      // get min width from col class
      const classGridsize = className.split("-")[0];
      // check this is a string not a number, this will remove up cols that dont have a grid size e.g. col-1-2
      if (isNaN(classGridsize)) {
        className = className.replace(classGridsize + "-", "");
        classWidth = gridSizes[classGridsize];
      } else {
        classWidth = 0;
      }
      // split rest of class into sections (this should now be something like '1-4')
      const otherClassParts = className.split("-");
      // divide second number (e.g 4) by first number (e.g 1) to get number of items
      if (otherClassParts[1]) {
        numItems = otherClassParts[1] / otherClassParts[0];
      } else {
        numItems = 1; // if there isn't a second number it must be a single grid
      }
      responsiveArray[classWidth] = {
        items: numItems
      };
    }
  });

  return responsiveArray;
} // carouselResponsiveArray();

/*  ==========================================================================
    Map Fade Carousel
    ========================================================================== */

function mapCarouselInit() {
  const mapCarousels = document.querySelectorAll(".map__carousel");

  let intervalTimeout = 7000, // milliseconds between transitions
    index = 0; // starting index
  let zoomSpeed = 1100; // needs to match css transition speed
  let zoomResetTimeout = intervalTimeout - zoomSpeed;

  mapCarousels.forEach(carousel => {
    index = 0;

    const slides = carousel.querySelectorAll(".carousel__slide");

    // Init first slide
    slides[index].classList.add("active");

    let slideCount = slides.length;

    // Setup transform origins
    slides.forEach(slide => {
      let originX = slide.dataset.originx;
      let originY = slide.dataset.originy;
      slide.querySelector(".slide__svg").style.transformOrigin = "" + originX + "% " + originY + "%";
    });

    if (slides.length > 1) {
      // the transition loop

      // Initial animation on first slide
      setTimeout(function () {
        // Animate zoom in on svg points
        let zoomScale = slides[index].dataset.zoomscale;
        slides[0].querySelector(".slide__svg").style.transform = "scale(" + zoomScale + ")";
      }, 500);
      setTimeout(function () {
        // Animate zoom back out ready for next map
        slides[0].querySelector(".slide__svg").style.transform = "scale(1)";
      }, zoomResetTimeout);

      setInterval(function () {
        slides[index].classList.remove("active");

        // get the next index, or cycle back to 0
        if (++index === slideCount) {
          index = 0;
        }
        // fade in the next image

        slides[index].querySelector(".slide__svg").style.transform = "scale(1)";
        slides[index].classList.add("active");

        setTimeout(function () {
          // Animate zoom in on svg points
          let zoomScale = slides[index].dataset.zoomscale;
          slides[index].querySelector(".slide__svg").style.transform = "scale(" + zoomScale + ")";
        }, 500);

        setTimeout(function () {
          // Animate zoom back out ready for next map
          slides[index].querySelector(".slide__svg").style.transform = "scale(1)";
        }, zoomResetTimeout);
      }, intervalTimeout);
    }
  });
}
mapCarouselInit();

/*  ==========================================================================
	NAVIGATION - sitenav
	========================================================================== */
const siteheader = document.querySelector(".siteheader:not(.siteheader--padder)");

const sitenavScrolled = function () {
  if (window.scrollY > 50) {
    siteheader.classList.add("siteheader--scrolled");
  } else {
    siteheader.classList.remove("siteheader--scrolled");
  }
};

document.addEventListener("scroll", sitenavScrolled);

sitenavScrolled();

/*  ==========================================================================
	NAVIGATION - mobnav
	========================================================================== */

const mobnav = document.querySelector(".mobnav");
const siteHeaderBd = document.querySelector(".siteheader__bd");
const mobnavToggle = document.querySelectorAll(".mobnav-toggle");
const mobnavOpenclass = "mobnavopen";

const mobnavInit = function () {
  // Open mobnav on click the toggle
  mobnavToggle.forEach(item =>
    item.addEventListener("click", function (e) {
      e.preventDefault();

      body.classList.toggle(mobnavOpenclass);
    })
  );
}; // mobnavInit()
mobnavInit();

/*  ==========================================================================
      NAVIGATION - mobnav dropdowns
      ========================================================================== */

const mobnavLinks = document.querySelectorAll(".mobnav .sitenav__item--hasdropdown .sitenav__item__dropdownarrow");

const mobnavlinksInit = function () {
  if (!mobnavLinks) {
    return;
  }

  mobnavLinks.forEach(function (mobnavLink) {
    mobnavLink.addEventListener("click", function (e) {
      e.preventDefault();
      const mobnavTargetSection = e.target.closest(".sitenav__item");
      mobnavTargetSection.classList.toggle("sitenav__item--open");
    });
  });
}; // mobnavlinksInit();
mobnavlinksInit();

/*  ==========================================================================
	NAVIGATION - Search
	========================================================================== */

// Search open & close
const searchNav = document.querySelector(".siteheader__search");
const searchToggle = document.querySelector(".search-toggle");
const searchInput = document.querySelector(".siteheader__search .searchform__input input");

// Close search modal when clicked elsewhere in the document
const clickedOusideSearch = function (e) {
  if (!searchNav.classList.contains("siteheader__search--open")) {
    return;
  }

  var isClickInsideElement =
    searchNav.contains(e.target) || searchToggle === e.target || searchToggle.contains(e.target);

  if (!isClickInsideElement) {
    searchNav.classList.remove("siteheader__search--open");
    body.removeEventListener("mouseup", clickedOusideSearch, false);
  }
}; // clickedOusideSearch();

// Toggle search modal window
const searchModalToggle = function (e) {
  e.preventDefault();
  if (searchNav.classList.contains("siteheader__search--open")) {
    searchNav.classList.remove("siteheader__search--open");
    body.removeEventListener("mouseup", clickedOusideSearch, false);
  } else {
    searchNav.classList.add("siteheader__search--open");
    searchInput.focus();
    body.addEventListener("mouseup", clickedOusideSearch, false);
  }
}; // searchModalToggle();

const searchModalInit = function () {
  if (!searchNav) {
    return;
  }
  searchToggle.addEventListener("click", searchModalToggle);
}; // searchModalInit();

//searchModalInit();

/*  ==========================================================================
    Scroll to anchor links - .pagenav, .readmore buttons 
    ========================================================================== */

const pagenavInnit = function () {
  const pagenavLinks = document.querySelectorAll(".scrolltolink");

  if (!pagenavLinks) {
    return;
  }

  pagenavLinks.forEach(function (el) {
    el.addEventListener("click", function (e) {
      e.preventDefault();

      const id = el.getAttribute("href");
      const siteheader = document.querySelector(".siteheader:not(.siteheader--padder)");
      const pagenav = document.querySelector(".pagenav");

      const anchor = document.querySelector(id).getBoundingClientRect();

      // If there is a pagenav on the page
      let siteheaderHeight = siteheader.offsetHeight;
      if (pagenav) {
        siteheaderHeight = siteheader.offsetHeight + pagenav.offsetHeight;
      }

      // Check if it's a fancybox window
      if (document.querySelector(".fancybox-is-open")) {
        document.querySelector(".fancybox-content").scroll({
          top: anchor.top - siteheaderHeight,
          behavior: "smooth"
        });
      } else {
        window.scroll({
          top: window.scrollY + anchor.top,
          behavior: "smooth"
        });
      }
    });
  });
};

pagenavInnit();

/*  ==========================================================================
  Polyfill IE11 for forEach
  ========================================================================== */

  if ("NodeList" in window && !NodeList.prototype.forEach) {
    NodeList.prototype.forEach = function (callback, thisArg) {
      thisArg = thisArg || window;
      for (var i = 0; i < this.length; i++) {
        callback.call(thisArg, this[i], i, this);
      }
    };
  }

/*  ==========================================================================
	FILTERS - Company Portfolio Filtering
	========================================================================== */

const filters = document.querySelector(".filters"),
  filtersToggle = document.querySelector(".filters__toggle"),
  filterSearchToggle = document.querySelector(".filters__search__toggle"),
  filterSearch = document.querySelector(".filters__search"),
  filterSearchClear = document.querySelector(".filters__search__clear"),
  filterSearchInput = document.querySelector(".filters__search__input input");

const filterPageURL = filters ? filters.dataset.url : "";

let filtersInitialLoad = true;

// Get current from filters data

const filterGetFormData = function () {
  let filter_data = {};

  filter_settings.filters.forEach(function (el) {
    let checkedOptions = document.querySelectorAll('input[type="checkbox"][name=' + el.name + "]:checked");
    filter_data[el.name] = [...checkedOptions].map(x => x.value);
  });

  return filter_data;
};

const filterUpdateURL = function (filterData, searchData) {
  let url_params = "";

  for (const [key, value] of Object.entries(filterData)) {
    if (value.length > 0) {
      if (url_params === "") {
        url_params = url_params + "?";
      } else {
        url_params = url_params + "&";
      }
      // Convert values to comma seperated string
      let values = Object.keys(value)
        .map(function (k) {
          return value[k];
        })
        .join(",");

      if (values !== "") {
        url_params = url_params + "filter_" + key + "=" + values;
      } else {
        url_params = "";
      }
    }
  }

  if (searchData) {
    if (url_params === "") {
      url_params = url_params + "?";
    } else {
      url_params = url_params + "&";
    }
    url_params = url_params + "search=" + searchData;
  }

  let currentPageUrl = window.location.href.split("?")[0];
  let newUrl = currentPageUrl + url_params;
  // history.pushState({ path: newUrl }, "", newUrl);

  if (url_params !== "") {
    history.pushState({}, "", newUrl);
    // console.log("history.pushState: ", newUrl);
  }

  if (history.pushState) {
    window.history.pushState({ path: newUrl }, "", newUrl);
  }
};

// Toggles All Content checkbox if there is selected filters within the group
const filterSelectedAllCheckboxes = function (groupName) {
  let noActiveFiltersInGroup = true;

  document.querySelectorAll('input[type="checkbox"][name=' + groupName + "]").forEach(el => {
    if (el.checked === true) {
      noActiveFiltersInGroup = false;
    }
  });
  const allGroupCheckbox = document.querySelector('input[type="checkbox"][name=all_' + groupName + "]");
  if (allGroupCheckbox) {
    allGroupCheckbox.checked = noActiveFiltersInGroup;
  }
};

// Setup up the active tags in the filter bar
const filterAddingActiveTags = function (filterData) {
  let hasClassActive = false;
  // Reset styles
  const fieldsets = document.querySelectorAll(".filters__fieldset");
  fieldsets.forEach(set => {
    set.classList.remove("filters__fieldset--active");
  });

  const fieldsetField = document.querySelectorAll(".filters__fieldset__field");
  fieldsetField.forEach(field => {
    field.classList.remove("filters__fieldset__field--active");
  });

  // Reset tags
  document.querySelector(".filters__tags").classList.remove("filters__tags--active");
  document.querySelector(".filters__activetags__tags").innerHTML = "";

  for (const [key, values] of Object.entries(filterData)) {
    if (values.length > 0) {
      // Make field group active
      document
        .querySelector(".filters__fieldset[data-value='" + key + "']")
        .classList.remove("filters__fieldset--active");

      for (const value of values) {
        // Make input field active

        let filter_input = document
          .querySelector("input[name='" + key + "'][value='" + value + "']")
          .closest(".filters__fieldset__field");

        filter_input.classList.add("filters__fieldset__field--active");
        // Show active tags
        document.querySelector(".filters__tags").classList.add("filters__tags--active");
        // Add tag
        let filter_input_name = filter_input.querySelector(".filters__fieldset__field__label").innerHTML;

        document.querySelector(
          ".filters__activetags__tags"
        ).innerHTML += `<div class="filters__tag" data-name="${key}" data-value="${value}">${filter_input_name} <i class="fas fa-times"></i></div>`;

        hasClassActive = true;
      }
    }

    filterSelectedAllCheckboxes(key);
  }

  return hasClassActive;
};

const filterGetPosts = function (updateURL = false) {
  // Getting the forma data
  let filterData = filterGetFormData();
  let searchData = filterSearchInput.value;

  if (filterData || searchData) {
    // Update url
    if (updateURL) {
      filterUpdateURL(filterData, searchData);
    }

    let activeTagsNotEmpty = filterAddingActiveTags(filterData);

    if ((filtersInitialLoad && (activeTagsNotEmpty || searchData)) || !filtersInitialLoad) {
      filtersInitialLoad = false;

      // get site padder header height
      let siteheaderpadder = document.querySelector(".siteheader--padder");
      let siteheaderpadderHeight = siteheaderpadder.offsetHeight;

      // get teams filter height
      let portFilter = document.querySelector(".filters");
      let portFilterHeight = portFilter.offsetHeight;

      let filterPin = document.querySelector(".filters-pin");

      const filterPinRec = filterPin.getBoundingClientRect();

      const top = window.scrollY + filterPinRec.top - portFilterHeight - siteheaderpadderHeight - 40;

      window.scrollTo({
        top: top,
        behavior: "smooth"
      });

      // If there's an active search, open the search field
      if (searchData) {
        document.querySelector(".filters__search").classList.add("filters__search--open");
        filterSearchClear.classList.add("active");
        // Show active tags
        document.querySelector(".filters__tags").classList.add("filters__tags--active");
      }

      // Start filtering
      document.querySelector(".posts.loadmore-container").classList.add("filtering");

      let getPostsPage = php_variables.current_page;
      const currentPage = new URL(window.location);
      let currentPageNum = currentPage.searchParams.get("pagenum");

      //If there is more than one page to load
      if (currentPageNum && currentPageNum > 1) {
        currentPageNum = currentPageNum > php_variables.max_page ? php_variables.max_page : currentPageNum;

        getPostsPage = currentPageNum;
      }

      // Trigger ajax
      let data = {
        action: "filter",
        query: php_variables.posts, // that's how we get params from wp_localize_script() function in enqueue-scripts.php
        page: php_variables.current_page,
        filter_settings: filter_settings, // passed in via wp_localize_script in filters.php
        filter_data: filterData,
        search_data: searchData
      };

      $.ajax({
        url: php_variables.ajax_url,
        data: data, // form data
        dataType: "json", // this data type allows us to receive objects from the server
        type: "POST",
        success: function (data) {
          // when filter applied:
          // set the current page to 1
          php_variables.current_page = 1;

          // set the new query parameters
          php_variables.posts = data.posts;

          // set the new max page parameter
          php_variables.max_page = data.max_page;

          // hide load more button, if there are not enough posts for the second page

          const pagingLoadmore = document.querySelector(".paging__loadmore");
          if (pagingLoadmore) {
            if (data.max_page < 2) {
              pagingLoadmore.style.display = "none";
            } else {
              pagingLoadmore.style.display = "block";
            }
          }

          // insert the posts to the container
          const loadmoreContainer = document.querySelector(".posts.loadmore-container");
          if (loadmoreContainer) {
            loadmoreContainer.innerHTML = data.content;
            // Finish filtering
            loadmoreContainer.classList.remove("filtering");
          }

          setFilterTagsListeners();

          lazyLoadInstance.update();

          Waypoint.refreshAll();

          // Re-do fancybox events
          setupFancyboxEvents();
        },
        error: function (data) {}
      });
    }
  }
};

const setFilterTagsListeners = function () {
  const allFilterTags = document.querySelectorAll(".filters__tag");
  allFilterTags.forEach(tag => {
    tag.addEventListener("click", function () {
      let filter_name = tag.dataset.name;
      let filter_value = tag.dataset.value;
      let filter_input = (document.querySelector(
        "input[name='" + filter_name + "'][value='" + filter_value + "']"
      ).checked = false);
      // Remove tag
      tag.remove();
      // Trigger filter
      filterGetPosts();
    });
  });
};

const filterSetupClearAll = function () {
  const filterClearAll = document.querySelectorAll(".filters__clearall");
  filterClearAll.forEach(btn => {
    btn.addEventListener("click", function () {
      // Clear search
      filterSearchInput.value = "";
      filterSearch.classList.remove("filters__search--open");
      filterSearchClear.classList.remove("active");

      // Remove all tags
      document.querySelector(".filters__tags").classList.remove("filters__tags--active");
      document.querySelector(".filters__activetags__tags").innerHTML = "";
      // Uncheck all inputs
      const filterCheckboxes = document.querySelectorAll(".filters__fieldset__field input");
      filterCheckboxes.forEach(el => (el.checked = false));

      // Trigger filter
      filterGetPosts(true);

      filters.classList.remove("filters--searchopen");
      filters.classList.remove("filters--dropdownopen");
    });
  });
};

// Init Filter on posts pages
const filterInit = function () {
  let currentPageUrl = window.location.href.split("?")[0];

  const submitBtn = document.querySelector(".filters__apply");
  const filterForm = document.querySelector(".filters__form");

  if (filterForm && filterForm.length) {
    // Get Posts based on Filter Form Data
    filterGetPosts(false);

    // Dropdown open & close
    filtersToggle.addEventListener("click", function (e) {
      e.stopPropagation();
      filters.classList.remove("filters--searchopen");
      filters.classList.toggle("filters--dropdownopen");
    });

    // Search open & close
    filterSearchToggle.addEventListener("click", function (e) {
      if (filterSearch.classList.contains("filters__search--open")) {
        filterSearch.classList.remove("filters__search--open");
      } else {
        filterSearch.classList.add("filters__search--open");
        filterSearchInput.focus();
      }
    });
    // Clear search on click
    filterSearchClear.addEventListener("click", function (e) {
      filterSearchInput.value = "";
      filterSearch.classList.remove("filters__search--open");
      filterSearchClear.classList.remove("active");
      filterGetPosts(true);
    });

    // Filter on submit
    filterForm.addEventListener("submit", function (e) {
      // Stop the form from submitting
      e.preventDefault();

      // Call the filtering post function
      filterGetPosts(true);
      filters.classList.remove("filters--searchopen");
      filters.classList.remove("filters--dropdownopen");
    });

    const filterCheckboxes = filterForm.querySelectorAll(".filters__fieldset__field input");

    filterCheckboxes.forEach(checkbox => {
      checkbox.addEventListener("change", function (evt) {
        // Submit for on checkbox click
        filterGetPosts(true);
        filters.classList.toggle("filters--dropdownopen");
      });
    });

    // Remove tags on click
    setFilterTagsListeners();

    // Clear all
    filterSetupClearAll();
  }
};

filterInit();

/*  ==========================================================================
	FILTERS - Teams Filtering
	========================================================================== */

const teamsFilterGetPosts = function (filterData) {
  if (filterData) {
    // Update url
    filterUpdateURL(filterData, false);

    // get site padder header height
    let siteheaderpadder = document.querySelector(".siteheader--padder");
    let siteheaderpadderHeight = siteheaderpadder.offsetHeight;

    // get teams filter height
    let teamsFilter = document.querySelector(".teamsfilter");
    let teamsFilterHeight = teamsFilter.offsetHeight;

    let filterPin = document.querySelector(".filters-pin");

    const filterPinRec = filterPin.getBoundingClientRect();

    const top = window.scrollY + filterPinRec.top - teamsFilterHeight - siteheaderpadderHeight - 40;

    window.scrollTo({
      top: top,
      behavior: "smooth"
    });

    // Start filtering
    document.querySelector(".posts.loadmore-container").classList.add("filtering");

    // Trigger ajax
    let data = {
      action: "filter",
      query: php_variables.posts, // that's how we get params from wp_localize_script() function in enqueue-scripts.php
      page: php_variables.current_page,
      filter_settings: filter_settings, // passed in via wp_localize_script in filters.php
      filter_data: filterData
    };

    $.ajax({
      url: php_variables.ajax_url,
      data: data, // form data
      dataType: "json", // this data type allows us to receive objects from the server
      type: "POST",
      success: function (data) {
        // when filter applied:
        // set the current page to 1
        php_variables.current_page = 1;

        // set the new query parameters
        php_variables.posts = data.posts;

        // set the new max page parameter
        php_variables.max_page = data.max_page;

        // hide load more button, if there are not enough posts for the second page

        const pagingLoadmore = document.querySelector(".paging__loadmore");
        if (pagingLoadmore) {
          if (data.max_page < 2) {
            pagingLoadmore.style.display = "none";
          } else {
            pagingLoadmore.style.display = "block";
          }
        }

        // insert the posts to the container
        const loadmoreContainer = document.querySelector(".posts.loadmore-container");
        if (loadmoreContainer) {
          loadmoreContainer.innerHTML = data.content;
          // Finish filtering
          loadmoreContainer.classList.remove("filtering");
        }

        setFilterTagsListeners();

        lazyLoadInstance.update();

        Waypoint.refreshAll();

        // Re-do fancybox events
        setupFancyboxEvents();
      },
      error: function (data) {}
    });
    // }
  }
};
const teamsFilterInit = function () {
  const filterLinks = document.querySelectorAll(".teamsfilter__link");

  if (filterLinks) {
    filterLinks.forEach(link => {
      if (link.classList.contains("pagenav__link--current") && !link.classList.contains("pagenav__link--all")) {
        let filterData = {};
        let linkValue = link.dataset.value;
        filterData[link.dataset.name] = [link.dataset.value];

        teamsFilterGetPosts(filterData);
      }

      link.addEventListener("click", function (e) {
        e.preventDefault();
        let filterData = {};
        let linkValue = link.dataset.value;

        //filterData[link.dataset.name] = [link.dataset.value];

        if (link.classList.contains("pagenav__link--current")) {
          link.classList.remove("pagenav__link--current");

          filterData = {};
          //splice(link.dataset.name, 1);
        } else {
          // let filterLinksWithoutLink = filterLinks.filter(function(element) {
          //   return element !== link;
          // });

          filterLinks.forEach(filterlink => {
            filterlink.classList.remove("pagenav__link--current");
          });

          link.classList.add("pagenav__link--current");

          // remove item from filterData

          filterData[link.dataset.name] = [link.dataset.value];
        }

        teamsFilterGetPosts(filterData);
      });
    });
  }
};
teamsFilterInit();
